import React from 'react'

const React_Coding_Practice_17 = () => {
  return (
    <div>
      <h1>Coding Pratice 17</h1>
    </div>
  )
}

export default React_Coding_Practice_17
